import React from "react";
import { Badge, Divider, Form } from "antd";
import { downloadImg } from "@/utils/constant";
import * as DICT from "@/utils/dict"
import CONST from "@/dataSource/CONST"
import defaultImg from '@/assets/images/pic-error.png'
import { ImageList } from "@/components/Img";
import intl from "react-intl-universal";
import styles from "./alarmStatus.module.less";
import PropIcon from "@/components/Icon/PropIcon";
import http from "@/http"
import Tag from "@/components/Tag";
import BaseStatus from "../../overview/device/deviceInfo/components/BaseStatus";


class AlarmStatus extends React.Component {
    componentDidMount() {
    }

    render() {
        const { alarmInfo } = this.props;
        if (!(alarmInfo && alarmInfo.id && alarmInfo.id.length > 0)) return ``;

        if (alarmInfo.params && alarmInfo.params.length > 0) {
            alarmInfo.data = alarmInfo.params;
        }
        let getRow = (name, text) => (
            <div className={styles.row}>
                <span className={styles.name}>{name}</span>
                <div className={styles.text}>{text}</div>
            </div>
        )

        let dataList = [];
        if (alarmInfo.data && alarmInfo.data.length > 0) {
            let data = JSON.parse(alarmInfo.data);
            if (data && data.length > 0) {
                dataList = data.map(item => {
                    return (
                        <div className={styles.item}>
                            <span className={styles.name}>{item.name}:</span>
                            <span className={styles.text}>{item.value}</span>
                        </div>
                    )
                })
            }
        }

        return (
            <div className={styles.deviceInfoMain}>
                <div className={styles.row}>
                    <Tag className={styles.tag} color={alarmInfo.eventType}>
                        {alarmInfo.eventName}
                        <Divider className={styles.divider} type="vertical" />
                        {DICT.getValue(`EVENT_TYPE`, alarmInfo.eventType)}
                    </Tag>
                    <div className={styles.text}>{alarmInfo.time}</div>
                </div>
                <div className={styles.dataRow}>
                    {dataList}
                </div>

            </div>
        )
    }
}

export default AlarmStatus